import { render, staticRenderFns } from "./editActive.vue?vue&type=template&id=642474cf&scoped=true&"
import script from "./editActive.vue?vue&type=script&lang=js&"
export * from "./editActive.vue?vue&type=script&lang=js&"
import style0 from "./editActive.vue?vue&type=style&index=0&id=642474cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642474cf",
  null
  
)

export default component.exports